function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Form - Address Components
 * 
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { licenceAddress, licenceAddressLocality, licenceAddressPostcode, licenceAddressState, licenceAddressStreet, licenceDeliveryAddressLocality, licenceDeliveryAddressPostcode, licenceDeliveryAddressState, licenceDeliveryAddressStreet, licenceDeliveryAddressCountry, setI18n } from '../../actions/';
import Select from '../select/Select';
import TextInput from '../text-input/TextInput';
import { COUNTRIES, FIELDS, I18N, MAYBE_POSTCODE } from '../../data/Data';
import './AddressComponents.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SECTION = 'address-components';
export class AddressComponents extends React.Component {
  constructor(...args) {
    super(...args);
    /**
     * handle country change
     * this is only possible for international addresses
     */
    _defineProperty(this, "licenceDeliveryAddressCountry", async phoneCountryCode => {
      const {
        setI18n
      } = this.props;
      const url = `${I18N}${phoneCountryCode}`;
      const data = await fetch(url).then(response => {
        if (response.status >= 400) {
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(result => {
        return result;
      }).catch(error => console.warn(error));
      if (data) {
        setI18n(data);
      }
    });
    /**
     * handle street address change
     */
    _defineProperty(this, "handleStreetAddress", value => {
      const {
        name,
        licenceDeliveryAddressStreet,
        licenceAddressStreet
      } = this.props;
      switch (true) {
        case name === 'licenceDeliveryAddress':
          licenceDeliveryAddressStreet(value);
          break;
        default:
          licenceAddressStreet(value);
      }
    });
    /**
     * handle locality change
     */
    _defineProperty(this, "handleLocality", value => {
      const {
        name,
        licenceDeliveryAddressLocality,
        licenceAddressLocality
      } = this.props;
      switch (true) {
        case name === 'licenceDeliveryAddress':
          licenceDeliveryAddressLocality(value);
          break;
        default:
          licenceAddressLocality(value);
      }
    });
    /**
     * handle state address change
     */
    _defineProperty(this, "handleState", value => {
      const {
        name,
        licenceDeliveryAddressState,
        licenceAddressState
      } = this.props;
      switch (true) {
        case name === 'licenceDeliveryAddress':
          licenceDeliveryAddressState(value);
          break;
        default:
          licenceAddressState(value);
      }
    });
    /**
     * handle state address change
     */
    _defineProperty(this, "handlePostcode", value => {
      const {
        name,
        licenceDeliveryAddressPostcode,
        licenceAddressPostcode
      } = this.props;
      switch (true) {
        case name === 'licenceDeliveryAddress':
          licenceDeliveryAddressPostcode(value);
          break;
        default:
          licenceAddressPostcode(value);
      }
    });
  }
  render() {
    const {
      addresses,
      name
    } = this.props;
    let error = false;
    let stateLabel = 'State';
    let localityLabel = 'Suburb/town';
    let postcodeLabel = 'Postcode';
    let showState = true;
    let showPostcode = true;
    let country = '';
    let countries = [...COUNTRIES];
    let index = -1;
    for (let i = 0; i < countries.length; i++) {
      if (countries[i].value === 'AU') {
        index = i;
        break;
      }
      // no point going past Austria
      if (countries[i].value === 'AT') {
        break;
      }
    }
    if (index > -1) {
      countries.splice(index, 1);
    }
    switch (name) {
      case 'licenceAddress':
        if (!addresses.addressFieldsToggle) return null;
        error = addresses.licenceAddress?.error;
        break;
      case 'licenceDeliveryAddress':
        if (!addresses.addressDeliveryFieldsToggle) return null;
        stateLabel = addresses.licenceDeliveryAddressState?.label;
        localityLabel = addresses.licenceDeliveryAddressLocality?.label;
        postcodeLabel = addresses.licenceDeliveryAddressPostcode?.label;
        country = addresses.licenceDeliveryAddressCountry?.value;
        if (!addresses.licenceDeliveryAddressState?.required) {
          showState = false;
        }
        if (!addresses.licenceDeliveryAddressPostcode?.required && MAYBE_POSTCODE.indexOf(country) === -1) {
          showPostcode = false;
        }
        break;
      default:
      // no op
    }
    return /*#__PURE__*/_jsx("div", {
      className: `form-element-container address-components${error ? ' error' : ''}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: "manual-address",
        children: [name === 'licenceDeliveryAddress' && addresses.licenceDelivery === 'International' ? /*#__PURE__*/_jsx(Select, {
          autoComplete: "country",
          handleChange: this.licenceDeliveryAddressCountry,
          onBlur: () => null,
          label: 'Country',
          name: `${name}Country`,
          options: countries,
          section: SECTION,
          values: addresses
        }) : null, /*#__PURE__*/_jsx(TextInput, {
          autoComplete: "street-address",
          handleChange: this.handleStreetAddress,
          onBlur: this.handleStreetAddress,
          label: 'Street address',
          name: `${name}Street`,
          section: SECTION,
          values: addresses
        }), /*#__PURE__*/_jsx(TextInput, {
          handleChange: this.handleLocality,
          onBlur: this.handleLocality,
          label: localityLabel,
          name: `${name}Locality`,
          section: SECTION,
          values: addresses
        }), /*#__PURE__*/_jsxs("div", {
          className: "state-postcode",
          children: [showState ? /*#__PURE__*/_jsx(Select, {
            handleChange: this.handleState,
            onBlur: () => null,
            label: stateLabel,
            name: `${name}State`,
            options: addresses[`${name}State`].states,
            section: SECTION,
            values: addresses
          }) : null, showPostcode ? /*#__PURE__*/_jsx(TextInput, {
            handleChange: this.handlePostcode,
            onBlur: this.handlePostcode,
            label: postcodeLabel,
            name: `${name}Postcode`,
            section: SECTION,
            values: addresses
          }) : null]
        })]
      })
    });
  }
}
_defineProperty(AddressComponents, "defaultProps", {
  addresses: FIELDS,
  error: false,
  name: 'addressComponents',
  required: false,
  section: 'address-components'
});
const mapStateToProps = ({
  addresses
}) => {
  return {
    addresses
  };
};
const mapDispatchToProps = dispatch => {
  return {
    licenceAddress: value => {
      dispatch(licenceAddress(value));
    },
    licenceAddressLocality: value => {
      dispatch(licenceAddressLocality(value));
    },
    licenceAddressPostcode: value => {
      dispatch(licenceAddressPostcode(value));
    },
    licenceAddressStreet: value => {
      dispatch(licenceAddressStreet(value));
    },
    licenceAddressState: value => {
      dispatch(licenceAddressState(value));
    },
    licenceDeliveryAddressLocality: value => {
      dispatch(licenceDeliveryAddressLocality(value));
    },
    licenceDeliveryAddressPostcode: value => {
      dispatch(licenceDeliveryAddressPostcode(value));
    },
    licenceDeliveryAddressState: value => {
      dispatch(licenceDeliveryAddressState(value));
    },
    licenceDeliveryAddressStreet: value => {
      dispatch(licenceDeliveryAddressStreet(value));
    },
    licenceDeliveryAddressCountry: value => {
      console.log(value);
      dispatch(licenceDeliveryAddressCountry(value));
    },
    setI18n: data => {
      dispatch(setI18n(data));
    }
  };
};
const VisibleAddressComponents = connect(mapStateToProps, mapDispatchToProps)(AddressComponents);
export default VisibleAddressComponents;